export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAADCAYAAACj1j4PAAAAHUlEQVQImWMsKCjoYCADsDAwMJSTq7GCZF0MDAwAhpMC0eQlEVUAAAAASUVORK5CYII="